/**
 * Warning
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides all helper functions for warning generation and checks.
 */
export const checkForWarning = (objectSections, clampApproval, standApproval, vue) => {
  let warningMessage = '';
  objectSections.forEach((section, index) => {
    if (section.stand && section.stand.length < 200 / 500 && (!section.clamp1 && !section.clamp2)) {
      if (clampApproval[index] && (clampApproval[index].first || clampApproval[index].second)) {
        warningMessage = vue.$t('warnings.recommendedXS');
        if (
          standApproval
          && standApproval[index]
          && standApproval[index].stand.distanceFront >= 0.3
          && standApproval[index].stand.distanceBack >= 0.3
        ) {
          warningMessage = vue.$t('warnings.recommendedXSClamp');
        }
      } else if (
        standApproval
        && standApproval[index]
        && standApproval[index].stand.distanceFront >= 0.3
        && standApproval[index].stand.distanceBack >= 0.3
      ) {
        warningMessage = vue.$t('warnings.recommendedXSBigger');
      } else {
        warningMessage = vue.$t('warnings.recommendedXSNoOption');
      }
    }
    if (
      (section.clamp1 || section.clamp2)
      && (clampApproval && !clampApproval[index].first && !clampApproval[index].second)
    ) {
      warningMessage = vue.$t('warnings.clampBorders');
    }

    if (
      section.stand
      && standApproval
      && standApproval[index]
      && (standApproval[index] && (!standApproval[index].stand
        || standApproval[index].stand.distanceFront < section.stand.length / 2 - 0.01
        || standApproval[index].stand.distanceBack < section.stand.length / 2 - 0.01
      ))
    ) {
      warningMessage = vue.$t('warnings.standBorders');
    }
  });
  vue.$store.dispatch('setVisualizationWarning', warningMessage);
};

export const warning = (val) => {
  console.log(val);
};
